import React, { useEffect, useState } from "react";
import { Link } from 'react-router-dom';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';

function About() {
  return (
    <>
      <div class="breadcrumb-option">
        <div class="container">
          <div class="row">
            <div class="col-lg-12">
              <div class="breadcrumb__links">
                <Link to="/bazaar" data-discover="true"><i class="fa fa-home"></i> Home</Link><span>About</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="rows">
          <section>Pargati Bazaar is a bustling and colorful marketplace that offers a unique blend of traditional charm and modern convenience. Known for its lively atmosphere and diverse range of products, it serves as a one-stop destination for locals and tourists alike.</section>
          <section>From fresh produce, spices, and street food to clothing, electronics, and household items, the bazaar showcases the dynamic spirit of local commerce. Vendors set up tightly packed stalls, calling out to passersby with enticing deals and authentic goods, creating a sensory experience full of sights, sounds, and smells.</section>
          <section>The bazaar also reflects the cultural richness of the community, often featuring handmade crafts, regional textiles, and festive décor. Whether you're shopping for daily essentials or hunting for unique finds, Pargati Bazaar offers an engaging experience that captures the heart of local life.</section>
        </div>
      </div>
    </>
  );
}

export default About;
